<kendo-dialog *ngIf="dialogOpened" id="channelStatusDialog" title="{{'UPDATE-CHANNEL-STATUS' | translate}}"
    (close)="closeDialog()" [height]="250" [minWidth]="200" [width]="450">
    <form class="k-form-inline p-2" [formGroup]="editForm">
        <label class="k-form-field">
            <span class="k-text-uppercase dark">{{ 'STATUS' | translate }} *</span>
            <kendo-combobox required [data]="channelStatuses" formControlName="status" [valuePrimitive]="true"
                [textField]="'text'" [valueField]="'value'" [filterable]="false" [itemDisabled]="itemDisabled"
                [placeholder]="'SELECT' | translate" class="w-75">
                <ng-template kendoComboBoxItemTemplate let-dataItem>
                    <span innerHTML="{{ dataItem.value | uppercase | translate }}">
                    </span>
                </ng-template>
            </kendo-combobox>
        </label>
    </form>
    <div style="position:absolute;bottom:15px;">* {{'REQUIRED-FIELDS' | translate}}</div>
    <kendo-dialog-actions>
        <button kendoButton (click)="closeDialog()">{{'CANCEL' | translate}}</button>
        <button appPreventClick kendoButton (click)="updateStatus();"
            [disabled]="!editForm.valid || !editForm.dirty">{{'SAVE' | translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>